<template>
  <!-- 历史任务 -->
  <div style="position: relative;">
    <el-form style="margin:5px 0" ref="formMyHistoryTask" :model="formFilter" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="流水号" prop="serialNo">
            <el-input
              v-model="formFilter.serialNo"
              :clearable="true" placeholder="流水号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="流程名称" prop="processDefinitionName">
            <el-select style="width:100%" v-model="formFilter.processDefinitionName" placeholder="流程名称" clearable>
              <el-option-group
                v-for="group in options"
                :key="group.processDefinitionKey"
                :label="group.processDefinitionName">
                <el-option
                  v-for="item in group.children"
                  :key="item.processDefinitionKey"
                  :label="item.processDefinitionName"
                  :value="item.processDefinitionKey">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工程名称/文号" prop="runName">
            <el-input
              v-model="formFilter.runName"
              :clearable="true" placeholder="工程名称/文号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款人" prop="skr">
            <el-input
              v-model="formFilter.skr"
              :clearable="true" placeholder="收款人"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工程名称" prop="formFilter.gcmc">
            <el-select style="width:100%" filterable  :clearable="true" v-model="formFilter.gcmc" placeholder="工程名称">
              <el-option
                v-for="(item,index) in projectList"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="合同名称" prop="formFilter.htmc">
            <el-select style="width:100%" filterable  :clearable="true" v-model="formFilter.htmc" placeholder="合同名称">
              <el-option
                v-for="(item,index) in contractList"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-button type="primary" :plain="true" :size="defaultFormItemSize" @click="handleSearch">查询</el-button>
            <el-button type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="teacher" :data="formMyHistoryTaskWidget.dataList" :size="defaultFormItemSize" @sort-change="formMyHistoryTaskWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <!-- <el-table-column label="序号" header-align="center" align="center" type="index" width="100px" :index="formMyHistoryTaskWidget.getTableIndex" /> -->
          <el-table-column label="流水号" prop="serialNo" width="130px"  />
          <el-table-column label="流程名称" prop="processDefinitionName" width="200px"  />
          <el-table-column label="文号" prop="runName" width="600px" show-overflow-tooltip>
            <template slot-scope="scope">
               <span>{{ scope.row && scope.row.runName ? scope.row.runName : (scope.row && scope.row.masterData ? scope.row.masterData.run_name : '') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收款人" prop="skr" width="250px"/>
          <el-table-column label="发起人" prop="userShowName" width="150px"/>
          <el-table-column label="发起时间" prop="createTime" width="200px"  />
          <el-table-column label="状态" prop="flowStatusName">
            <template slot-scope="scope">
               <span v-if="scope.row.isReject" style="color:red">退回</span>
               <span v-else :style="{'color':color[scope.row.flowStatusName]}">{{scope.row.flowStatusName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope">
              <el-button class="table-btn" :size="defaultFormItemSize" type="text" @click="getFlow(scope.row)">流程图</el-button>
              <el-button class="table-btn success"  :size="defaultFormItemSize" type="text" @click="onFlowDetail(scope.row)">详情</el-button>
              <el-button v-if="doType === 2 && scope.row.flowStatus === 0 && !scope.row.isReject" class="table-btn delete"  :size="defaultFormItemSize" type="text" @click="handleWithdraw(scope.row)">撤回</el-button>
              <el-button v-if="doType === 2 && (scope.row.isReject || scope.row.flowStatus === 5 || scope.row.flowStatus === -1)" class="table-btn delete"  :size="defaultFormItemSize" type="text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="formMyHistoryTaskWidget.totalCount"
            :current-page="formMyHistoryTaskWidget.currentPage"
            :page-size="formMyHistoryTaskWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="formMyHistoryTaskWidget.onCurrentPageChange"
            @size-change="formMyHistoryTaskWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col> 
    </el-row>
    <el-dialog
      :visible="visible"
      width="1000px"
      top='5vh'
      :before-close="onClose"
    >
      <formTaskProcessViewer v-if="record.processDefinitionId && visible"  :flag="false"  :processDefinitionId='record.processDefinitionId'  :processInstanceId='record.processInstanceId' />
    </el-dialog>
    
  </div>
</template>

<script>

import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { TableWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { FlowOperationController } from '@/api/flowController.js';
import {SysFlowWorkOrderStatus} from "@/staticDict/flowStaticDict";
import formTaskProcessViewer from "./formTaskProcessViewer.vue";
import { OnlineOperation } from '@/api/onlineController.js';
export default {
  name: 'formMyHistoryTask',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  components:{
    formTaskProcessViewer
  },
  props:{
    options:{
      type :Array,
      default : () => []
    },
    doType:{
      type:Number
    }
  },
  data () {
    return {
      formFilter: {
        runName: undefined,
        serialNo: undefined,
        processDefinitionName: undefined,
        gcmc:undefined,
        htmc:undefined,
        skr:undefined
      },
      formFilterCopy: {
        runName: undefined,
        serialNo: undefined,
        processDefinitionName: undefined,
        gcmc:undefined,
        htmc:undefined,
        skr:undefined
      },
      formMyHistoryTaskWidget: new TableWidget(this.loadMyHistoryTaskData, this.loadMyHistoryTaskVerify, true, false,null,false,null,localStorage.getItem('page') ? JSON.parse(localStorage.getItem('page')).pageParam.pageNum : 1),
      isInit: false,
      record:{

      },
      visible:false,
      projectList:[],
      contractList:[],
       color:{ '处理中' : 'rgb(0, 128, 0)','审批中' : 'rgb(0, 128, 0)','已拒绝' : 'rgb(0, 128, 0)','已办结' : 'rgb(255, 0, 0)','已结束' : 'rgb(255, 0, 0)', '已撤销' : '#999','暂存':'#000'}, //任务状态color
    }
  }, 
  created() {
    this.formFilter.doType = this.doType
    this.formFilter.formFilterCopy = this.doType
    this.init()
    const row = JSON.parse(localStorage.getItem('task'))
    if (row) {
      this.onFlowDetail(row)
    }
    const search = JSON.parse(localStorage.getItem('search'))
    if (search) {
      this.formFilter = search
      this.formFilterCopy = search
    }
  },
  mounted() {
    localStorage.removeItem('page')
  },
  destroy () {
      this.formFilter = {
        runName: undefined,
        serialNo: undefined,
        processDefinitionName: undefined,
        gcmc:undefined,
        htmc:undefined,
        skr:undefined
      }
      this.formFilterCopy = {
        runName: undefined,
        serialNo: undefined,
        processDefinitionName: undefined,
        gcmc:undefined,
        htmc:undefined,
        skr:undefined
      }
  },
  methods: {
    handleSearch(){
      this.refreshFormMyHistoryTask(true)
      localStorage.removeItem('page')
    },
    init(){
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res=>{
        this.projectList = res.data
      })
      OnlineOperation.listDict(this, {
        dictId: '1684463201976061952'
      }).then(res=>{
        this.contractList = res.data
      })
    },
    onReset () {
      this.formFilter = {
        runName: undefined,
        serialNo: undefined,
        processDefinitionName: undefined,
        gcmc:undefined,
        htmc:undefined,
        skr:undefined
      }
      this.formFilterCopy = {
        runName: undefined,
        serialNo: undefined,
        processDefinitionName: undefined,
        gcmc:undefined,
        htmc:undefined,
        skr:undefined
      }
      this.refreshFormMyHistoryTask(true);
      localStorage.removeItem('search')
    },
    // 删除
    handleDelete(record){
      this.$confirm('是否删除此工单？').then(res => {
        FlowOperationController.deleteRecord(this,{processInstanceId:record.processInstanceId}).then(res => {
          this.formMyHistoryTaskWidget.refreshTable();
          this.$message.success('删除成功！');
        })
      }).catch(e => {});
    },
    // 撤回 
    handleWithdraw(record){
      if(!record.runtimeTaskInfoList.length) return
      this.$confirm('是否撤回此工单？').then(res => {
        const data = {
          taskId:record.runtimeTaskInfoList[0].taskId,
          processInstanceId:record.processInstanceId,
          comment:'撤回'
        }
        FlowOperationController.withdraw(this,data).then(res => {
          this.formMyHistoryTaskWidget.refreshTable();
          this.$message.success('撤回成功！');
        })
      }).catch(e => {});
    },
    /**
     * 获取所有流程实例
     */
    loadMyHistoryTaskData (params) {
      if (params == null) params = {};
      if(params.pageParam.pageNum !== 1) {
        localStorage.setItem('page',JSON.stringify(params))
      } else {
        localStorage.removeItem('page')
      }
      params = {
        ...params,
        flowWorkOrderDtoFilter:{
          runName: this.formFilterCopy.runName,
          serialNo: this.formFilterCopy.serialNo,
          processDefinitionName: this.formFilterCopy.processDefinitionName,
          doType: this.doType,
          gcmc:this.formFilterCopy.gcmc,
          htmc:this.formFilterCopy.htmc,
          skr:this.formFilterCopy.skr
        }
      }

      return new Promise((resolve, reject) => {
        FlowOperationController.listHistoricProcessInstanceAll(this, params).then(res => {
          if (res.data.dataList.length > 0) {
            res.data.dataList.forEach(item => {
              item.flowStatusName = SysFlowWorkOrderStatus.getValue(item.flowStatus)
            })
          }
          this.dataList = res.data.dataList
          this.total = res.data.totalCount
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadMyHistoryTaskVerify () {
      this.formFilterCopy.runName = this.formFilter.runName
      this.formFilterCopy.serialNo = this.formFilter.serialNo
      this.formFilterCopy.processDefinitionName = this.formFilter.processDefinitionName
      this.formFilterCopy.gcmc = this.formFilter.gcmc
      this.formFilterCopy.htmc = this.formFilter.htmc
      this.formFilterCopy.skr = this.formFilter.skr
      return true;
    },
    refreshFormMyHistoryTask (reloadData = false) {
      if (reloadData) {
        this.formMyHistoryTaskWidget.refreshTable(true, 1);
      } else {
        this.formMyHistoryTaskWidget.refreshTable();
      }
      if (!this.isInit) {
        // 初始化下拉数据
      }
      this.isInit = true;
      localStorage.setItem('search',JSON.stringify(this.formFilterCopy))
    },
    onFlowDetail (row) {
      localStorage.setItem('task',JSON.stringify(row))
      let params = {
        processInstanceId: row.processInstanceId
      }
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              serialNo:row.serialNo,
              processDefinitionKey: row.processDefinitionKey,
              taskId: null,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              flag: false, // change wang 2023/3/10
              flowStatus: row.flowStatusName,
              form:true
            }
          });
        }
      }).catch(e => {});
    },
    onResume () {
      this.refreshFormMyHistoryTask();
    },
    initFormData () {
    },
    formInit () {
      this.refreshFormMyHistoryTask();
    },
    // 查看流程图
    getFlow(record){
      this.record = record
      this.visible = true
    },
    onClose(){
      this.visible = false
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style>
</style>
